import { render, staticRenderFns } from "./RedesFqa.vue?vue&type=template&id=00909b10&scoped=true"
import script from "./RedesFqa.vue?vue&type=script&lang=js"
export * from "./RedesFqa.vue?vue&type=script&lang=js"
import style0 from "./RedesFqa.vue?vue&type=style&index=0&id=00909b10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00909b10",
  null
  
)

export default component.exports